import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Phone, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { useCatalog } from "../contexts/CatalogContext";

export default function Footer() {
  const { categories: CATEGORIES, CONTACT } = useCatalog();

  return (
    <footer className="bg-[#0F172A] text-slate-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="bg-white rounded-xl px-4 py-3 inline-block">
              <Logo testId="footer-logo" />
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Service. Technology. Trust. Reliable home appliance services across Lucknow.
            </p>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white text-sm uppercase tracking-wider mb-4">Services</h4>
            <ul className="space-y-2 text-sm">
              {CATEGORIES.map((c) => (
                <li key={c.id}>
                  <Link to={`/services?category=${c.id}`} data-testid={`footer-service-${c.id}`} className="hover:text-[#0EA5A4] transition-colors">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white text-sm uppercase tracking-wider mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-[#0EA5A4] transition-colors" data-testid="footer-about">About</Link></li>
              <li><Link to="/pricing" className="hover:text-[#0EA5A4] transition-colors" data-testid="footer-pricing">Pricing</Link></li>
              <li><Link to="/contact" className="hover:text-[#0EA5A4] transition-colors" data-testid="footer-contact">Contact</Link></li>
              <li><Link to="/join-as-technician" className="hover:text-[#0EA5A4] transition-colors" data-testid="footer-join">Join as Technician</Link></li>
              <li><Link to="/privacy" className="hover:text-[#0EA5A4] transition-colors" data-testid="footer-privacy">Privacy Policy</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white text-sm uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={CONTACT.whatsappLink} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#0EA5A4]" data-testid="footer-whatsapp">
                  <MessageCircle className="w-4 h-4" /> WhatsApp
                </a>
              </li>
              <li>
                <a href={CONTACT.phoneLink} className="flex items-center gap-2 hover:text-[#0EA5A4]" data-testid="footer-phone">
                  <Phone className="w-4 h-4" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={CONTACT.emailLink} className="flex items-center gap-2 hover:text-[#0EA5A4]" data-testid="footer-email">
                  <Mail className="w-4 h-4" /> {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 text-xs text-slate-500 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
          <div>© {new Date().getFullYear()} Repairro. All rights reserved.</div>
          <div>repairro.com — Modern RO & home service care.</div>
        </div>
      </div>
    </footer>
  );
}
